<template>
  <div class="row mb-5 total-sale">
    <div class="col-6">
      <div class="col-12 card p-0">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col-12 col-md-6 content-left row no-gutters pt-3 pb-3">
              <div v-for="(sale, index) in totalSale.sale_price" :key="index" class="col-12">
                <div class="widget-content">
                  <div class="widget-content-wrapper flex-wrap justify-content-around">
                    <div class="widget-content-left ml-2 mr2">
                      <div class="widget-heading text-warning">
                        {{ new Intl.NumberFormat().format(sale || 0) }}
                      </div>
                      <div class="widget-subheading">Sales ({{ this.currency.sale[index] ? this.currency.sale[index].label : index }})</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 widget-chart">
              <div class="widget-numbers">{{ totalSale.number || 0 }}</div>
              <div class="widget-subheading">Total Sales</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="col-12 card p-0 h-100">
        <div class="card-body">
          <div class="row no-gutters align-items-center justify-content-center h-100">
            <div v-for="(purchase, index) in totalSale.purchase_price" :key="index" class="widget-content">
              <template v-if="purchase > 0">
                <div class="widget-numbers h2">{{ new Intl.NumberFormat().format(purchase) }}</div>
                <div class="widget-subheading">Total Purchase({{ this.currency.purchase[index] != undefined ? this.currency.purchase[index].label : index.toUpperCase() }})</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config
    },
    currency() {
      let currency = Object.assign({}, this.data?.currency || {})
      currency.purchase = Object.assign({}, currency?.purchase || {}, {
        '': {
          label: ''
        }
      })
      return currency
    },
    totalSale() {
      return this.data?.total_sale?.status_total || {}
    }
  },
  props: {
    config: Object
  }
}
</script>
